import { render, staticRenderFns } from "./role_market.vue?vue&type=template&id=4c2ddf50&scoped=true&"
import script from "./role_market.vue?vue&type=script&lang=js&"
export * from "./role_market.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ddf50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2ddf50')) {
      api.createRecord('4c2ddf50', component.options)
    } else {
      api.reload('4c2ddf50', component.options)
    }
    module.hot.accept("./role_market.vue?vue&type=template&id=4c2ddf50&scoped=true&", function () {
      api.rerender('4c2ddf50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/roles/row/tabs/role_market.vue"
export default component.exports